import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=af740882&scoped=true&"
import script from "./ClientsList.vue?vue&type=script&lang=js&"
export * from "./ClientsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=af740882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af740882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af740882')) {
      api.createRecord('af740882', component.options)
    } else {
      api.reload('af740882', component.options)
    }
    module.hot.accept("./ClientsList.vue?vue&type=template&id=af740882&scoped=true&", function () {
      api.rerender('af740882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clients/ClientsList.vue"
export default component.exports